import React from "react";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <p className="footer-bar">
        Copyright <span className="footer-copy">&copy;</span> {currentYear} <strong>Shoieb</strong>
        <span className="footer-dot">•</span>All Rights Reserved.
      </p>
    </footer>
  );
};

export default Footer;
